import React, { useEffect, useState } from 'react';
import { CalendarClock } from 'lucide-react';

import { WalletHistoryItem } from '../../../../utils/types';
import { formatToLocalDate } from '../../../../utils/utils';

import { getWalletHistory } from '../../../../../auth/_requests';
import { useAuth } from '../../../../../auth/Auth';

const WalletHistory: React.FC = () => {
  const { auth } = useAuth();
  const [history, setHistory] = useState<WalletHistoryItem[]>([]);

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        // setLoading(true);
        const response = await getWalletHistory(auth?.data.token);
        setHistory(response.data);
      } catch (error) {
        console.error('Error fetching offers:', error);
      } finally {
        // setLoading(false);
      }
    };
    fetchHistory();
  }, []);

  return (
    <div className='w-full'>
      <div className='space-y-4 w-full'>
        {history.map((item) => (
          <div key={item.rentCreditTransactionId} className='w-full'>
            <div className='p-6 rounded-[20px] border border-[#DEE2EF] bg-[linear-gradient(229deg,_#FFF_-13.57%,_#F2F4F9_113.63%)] w-full'>
              <div className='flex justify-between items-center w-full'>
                <div className='flex flex-col gap-1 max-w-[60%]'>
                  {' '}
                  {/* Limit width so truncate works */}
                  <span className='text-main text-base font-semibold truncate overflow-hidden whitespace-nowrap'>
                    {item.note}
                  </span>
                  {item.cardCompanyTypeValue && item.cardLast4Digits && (
                    <span className='text-light/70 text-sm font-medium'>
                      {item.cardCompanyTypeValue} - ending with {item.cardLast4Digits}
                    </span>
                  )}
                  <span className='text-light/70 text-sm'>
                    {formatToLocalDate(item.timestampAdded)}
                  </span>
                </div>
                <span
                  className={`text-base font-bold ${
                    item.rentCreditTransactionType === 'credit' ? 'text-success' : 'text-failure'
                  }`}
                >
                  {item.rentCreditTransactionType === 'debit' ? '-' : '+'}$
                  {Number(item.amount ?? 0).toLocaleString('en-US')}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {history.length === 0 && (
        <div className='bg-gray-50 rounded-xl p-8 text-center'>
          <CalendarClock className='h-12 w-12 mx-auto text-gray-400' />
          <h3 className='mt-4 text-lg font-medium text-gray-900'>No wallet history</h3>
          <p className='mt-1 text-sm text-gray-500'>
            You don't have any rent credits yet. Check out the available offers!
          </p>
        </div>
      )}
    </div>
  );
};

export default WalletHistory;
